export const validateEmailFormat = (email: string): string | boolean => {
  return (
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email) ||
    'INVALID_EMAIL_FORMAT' // Use the translation key directly of errorMessages which is translated in `FormTextInput`
  )
}
